export const createGetNoteRequest = (id) => {
  return {
    url: "/notes/" + id,
    method: "GET",
  };
};

export const createSaveNoteRequest = (note) => {
  let created_from_source_type = note.createdFromSourceType;
  let created_from_source_value = note.createdFromSourceValue;
  let status = note.status;
  let style = note.style;
  return {
    url: "/notes",
    method: "POST",
    data: {
      created_from_source_type,
      created_from_source_value,
      status,
      style,
    },
  };
};

export const createUpdateNoteRequest = (note) => {
  let title = note.title;
  let content = note.content;
  let status = note.status;
  let id = note.id;
  let create_from_source_type = note.createFromSourceType;
  let create_from_source_value = note.createFromSourceValue;
  let tags = note.tags;

  return {
    url: "/notes/" + id,
    method: "PUT",
    data: {
      title,
      content,
      status,
      create_from_source_type,
      create_from_source_value,
      tags,
    },
  };
};

export const createDeleteNoteRequest = (id) => {
  return {
    url: "/notes/" + id,
    method: "DELETE",
  };
};

export const createGetNotesRequest = () => {
  return {
    url: "/notes",
    method: "GET",
  };
};

export const createGetNotesQuickActions = () => {
  return {
    url: "/notes/ai_quick_actions",
    method: "GET",
  };
};

export const createNewPublicVoiceNoteLinkRequest = (status) => {
  return {
    url: "/notes/",
    method: "POST",
    data: {
      status,
    },
  };
};

export const createUpdatePublicVoiceNoteLinkRequest = (
  id,
  public_questions_text
) => {
  return {
    url: "/notes/" + id,
    method: "PUT",
    data: {
      public_questions_text,
    },
  };
};

